import { ref } from "@vue/composition-api";

export const tableHandler = (apiController, params) => {
  const dialogModel = ref(false);
  const editedItem = ref(null);
  const table = ref(null);
  const loading = ref(false);

  const tableOn = {
    "update:loading": ($event) => (loading.value = $event),
  };

  const newFilter = async (payload) => {
    await table.value?.newFilter(payload);
  };

  const onCopy = (item) => {
    const newItem = JSON.parse(JSON.stringify(item));
    if (newItem.uuid) {
      delete newItem.uuid;
    }
    editedItem.value = newItem;
    dialogModel.value = true;
  };

  const onCreate = () => {
    editedItem.value = null;
    dialogModel.value = true;
  };

  const onEdit = (item) => {
    editedItem.value = item;
    dialogModel.value = true;
  };

  const onNew = (item) => {
    if (editedItem.value) {
      table.value?.editItem(item);
      editedItem.value = null;
    } else table.value?.addItem(item);
  };

  const onRefresh = async () => {
    await table.value?.refresh();
  };

  return {
    dialogModel,
    editedItem,
    getter: (functionParams) => apiController.getter({ ...functionParams, ...params }),
    newFilter,
    onCopy,
    onCreate,
    onEdit,
    onNew,
    onRefresh,
    table,
    tableOn,
    tableLoading: loading,
    toggle: apiController.toggle,
  };
};
